import { useSearchParams } from "react-router-dom"
import { ShareSource } from "./components/share-source"
import { ShareEvent } from "./components/share-event"
import { ShareDestination } from "./components/share-destination"

export function SharePage() {
  const [params] = useSearchParams()
  const type = params.get("type")
  const id = params.get("id")

  if (!type || !id) {
    return <p className="text-muted-foreground">Invalid share link parameters</p>
  }

  switch (type) {
    case "source":
      return <ShareSource id={id} />
    case "event":
      return <ShareEvent id={id} />
    case "destination":
      return <ShareDestination id={id} />
    default:
      return <p className="text-muted-foreground">Unknown share type: {type}</p>
  }
}
